module.exports = __webpack_public_path__ + "img/location.9cb30fe1.svg";